export default {
      id: "spotmarket-usage",
      viewBox: "0 0 1331 1072",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#spotmarket",
      toString: function () {
        return this.url;
      }
    }